import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import authReducer from "../slices/authSlice";
import productReducer from "../slices/productSlice"; 
import userReducer from "../slices/userSlice";
import storage from "redux-persist/lib/storage";
import {persistStore,persistReducer,FLUSH,REHYDRATE,PAUSE,PERSIST,PURGE,REGISTER} from "redux-persist";

// Configuration de redux-persist
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth", "products", 'users'], 
};

// Combine les reducers
const rootReducer = combineReducers({
  auth: authReducer,
  products: productReducer, 
  users: userReducer, 
});

// Applique le persistReducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configuration du store Redux
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

// Création du persistor
export const persistor = persistStore(store);
